import axios from 'axios';
import { store } from '../redux/store';
import { logout } from 'components/../redux/actions/auth';

// Function to get CSRF token from cookies
export const getCsrfToken = () => {
    const name = 'csrftoken';
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i].trim();
            if (cookie.substring(0, name.length + 1) === name + '=') {
                cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                break;
            }
        }
    }
    return cookieValue;
};

const withAuth = (headers = {}) => {
    const accessToken = localStorage.getItem('userToken');
    return {
        ...headers,
        Authorization: `Token ${accessToken}`
    };
};

const base = (method, url, data = {}, headers = {}, params = {}, secure = true, responseType = 'json') => {
    if (secure) {
        return axios({
            method,
            url,
            data,
            headers: withAuth(headers),
            params,
            responseType
        }).catch((err) => {
            if (err.response.status === 401) {
                store.dispatch(logout());
                return err;
            } else {
                throw err;
            }
        });
    } else {
        return axios({
            method,
            url,
            data,
            headers,
            params,
            responseType
        });
    }
};

const ApiHelper = {};

const methods = ['get', 'post', 'put', 'patch', 'delete'];

methods.forEach((method) => {
    ApiHelper[method] = base.bind(null, method);
});

export default ApiHelper;
